// @flow

import * as React from 'react';
import classNames from '@ta/common.classnames';
import localize from '@ta/common.i18n';
import { Icon } from '@ta/styleguide.icon';
import type { NavLinkType } from '../types';
import SideBarNavItem from './SideBarNavItem';
import styles from './SideBarCollapsedMenu.less';

type State = {|
  /** If the menu is in a collapsed state this will return true (i.e. no links are shown under the "More" tab) */
  isCollapsed: boolean,
|};

type Props = {|
  /** The list of links that belong to the collapsed menu. */
  collapsedLinks: NavLinkType[],
|};

/** Component that renders the "More" tab in the side bar and toggles the collapsed links */
class SideBarCollapsedMenu extends React.Component<Props, State> {
  state: State = { isCollapsed: true };

  /** Toggle the state every time this function is called */
  toggleCollapsed = () => {
    this.setState({
      isCollapsed: !this.state.isCollapsed,
    });
  };

  render() {
    const containerClasses = classNames(styles.collapsedLinksContainer, {
      [styles.expanded]: !this.state.isCollapsed,
    });

    return (
      <div className={containerClasses}>
        <div onClick={this.toggleCollapsed} className={styles.toggleMoreLinks}>
          {/** 'More' */}
          {localize('common_more_capital_ffffe27f')}
          <Icon name="single-chevron-down" className={styles.singleChevronDown} />
        </div>
        <ul
          className={classNames(styles.collapsedLinks, {
            [styles.expandedLinks]: !this.state.isCollapsed,
          })}
        >
          {this.props.collapsedLinks.map(link => (
            <SideBarNavItem key={link.id} link={link} />
          ))}
        </ul>
      </div>
    );
  }
}

export default SideBarCollapsedMenu;
